/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { mcpMetadataExport } from "../funcs/mcpMetadataExport.js";
import { mcpMetadataGet } from "../funcs/mcpMetadataGet.js";
import { mcpMetadataSet } from "../funcs/mcpMetadataSet.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { GetMcpMetadataResponseBody } from "../models/components/getmcpmetadataresponsebody.js";
import { McpExport } from "../models/components/mcpexport.js";
import { McpMetadata as McpMetadata$Model } from "../models/components/mcpmetadata.js";
import {
  ExportMcpMetadataRequest,
  ExportMcpMetadataSecurity,
} from "../models/operations/exportmcpmetadata.js";
import {
  GetMcpMetadataRequest,
  GetMcpMetadataSecurity,
} from "../models/operations/getmcpmetadata.js";
import {
  SetMcpMetadataRequest,
  SetMcpMetadataSecurity,
} from "../models/operations/setmcpmetadata.js";
import { unwrapAsync } from "../types/fp.js";

export class McpMetadata extends ClientSDK {
  /**
   * exportMcpMetadata mcpMetadata
   *
   * @remarks
   * Export MCP server details as JSON for documentation and integration purposes. Exactly one of mcp_slug or mcp_server_id must be provided.
   */
  async export(
    request: ExportMcpMetadataRequest,
    security?: ExportMcpMetadataSecurity | undefined,
    options?: RequestOptions,
  ): Promise<McpExport> {
    return unwrapAsync(mcpMetadataExport(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getMcpMetadata mcpMetadata
   *
   * @remarks
   * Fetch the metadata that powers the MCP install page. Exactly one of toolset_slug or mcp_server_id must be provided.
   */
  async get(
    request?: GetMcpMetadataRequest | undefined,
    security?: GetMcpMetadataSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetMcpMetadataResponseBody> {
    return unwrapAsync(mcpMetadataGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setMcpMetadata mcpMetadata
   *
   * @remarks
   * Create or update the metadata that powers the MCP install page. Exactly one of toolset_slug or mcp_server_id must be provided.
   */
  async set(
    request: SetMcpMetadataRequest,
    security?: SetMcpMetadataSecurity | undefined,
    options?: RequestOptions,
  ): Promise<McpMetadata$Model> {
    return unwrapAsync(mcpMetadataSet(
      this,
      request,
      security,
      options,
    ));
  }
}
